// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'Sobre {0}',
    activity_plural: '1#{0} atividade#{0} atividades',
    add: 'Adicionar',
    add_activity_button: 'Adicionar atividade',
    add_activity_window_title: 'Criar atividade',
    AddMoreSpace: 'Atualize agora',
    all_projects_label: 'Todos os projetos',
    approve_label: 'Aprovar',
    archive_action_text: 'Arquivar',
    Attach: 'Anexar arquivo',
    attach_file_image: 'Anexar arquivo ou imagem',
    automation_purchase_notes: 'Por favor, entre em contato com <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> se desejar usar um método de pagamento diferente de um cartão de débito',
    automation_trial_expired: 'Seu teste expirou.',
    automation_trial_expired_notes: 'Por favor, entre em contato com nosso <a href=\'mailto:support@birdviewpsa.com\'>suporte@birdviewpsa.com</a> para obter mais assistência.',
    btn_reload: 'Recarregar',
    buy_subscription: 'Comprar assinatura',
    Cancel: 'Cancelar',
    change: 'Alterar',
    checkbox_list_text: 'Seleção múltipla',
    Close: 'Fechar',
    completeActivityConfirm: 'Você especificou que esta atividade está 100% concluída. Deseja completar a atividade? Pressione \'OK\' para alterar o status, ou \'Cancelar\' caso contrário.',
    completeActivityTitle: 'Deseja concluir esta atividade?',
    completeProjectConfirm: 'Você especificou que este projeto está 100% concluído. Deseja concluir este projeto? Pressione \'OK\' para mudar o status.',
    completeProjectTitle: 'Deseja concluir este projeto?',
    confirmCompleteActivityParents: 'Completar esta atividade não deixará atividades não concluídas neste projeto (atividade pai). Você deseja concluir o projeto ou a atividade pai, o que for apropriado, também?',
    confirmCompleteActivityParentsTitle: 'Definir status de {0} como concluído?',
    contact_us: 'Contate-nos',
    continue: 'Continuar',
    copy_link_feedback: 'Link copiado.',
    copyLink: 'Copiar link',
    custom_field_label: 'Campo personalizado',
    date_text: 'Data',
    DayAbbreviation: 'd',
    DayPluralFormat: '1#dia#dias',
    DayPluralFormatTemplate: '1#{0} dia#{0} dias',
    Delete: 'Excluir',
    delete_confirmation: 'Esta ação não pode ser desfeita.',
    delete_permanently_text: 'Excluir permanentemente',
    description_information: 'para {0}',
    disabled: 'Desativado',
    disabledUserText: '(desativado)',
    Download: 'Baixar',
    dropdown_text: 'Seleção',
    Duplicate: 'Duplicar',
    Edit: 'Editar',
    ElapsedTime_Ago: '{0} atrás',
    enabled: 'Ativado',
    Entity_Category: 'Categoria',
    Entity_Customer: 'Cliente',
    Entity_Issue: 'Questão',
    Entity_JobRole: 'Função de trabalho',
    Entity_OAuthAccountClient: 'Cliente OAuth',
    Entity_Portfolio: 'Portfólio',
    Entity_Priority: 'Prioridade',
    Entity_Project: 'Projeto',
    Entity_ProjectStatus: 'Status',
    Entity_Request: 'Solicitação',
    Entity_Task: 'Tarefa',
    Entity_TaskStatus: 'Status',
    Entity_User: 'Usuário',
    Error_CantFindObjectTemplate: 'A operação não pôde ser concluída pelos seguintes motivos: item (tipo: {entityName}, ID: {objectKey}) não encontrado no banco de dados. Isso pode ser devido à exclusão ou falta de permissão para visualizar o item. Consulte seu administrador da {brandName} para possíveis causas.',
    error_notFullyCompleted: 'Um objeto ou usuário envolvido foi excluído ou as permissões de acesso foram revogadas por outro usuário.',
    ErrorFileSizeLimit: 'O envio do arquivo {0} não pôde ser concluído, pois você não pode enviar um arquivo maior que ∼ {1} GB',
    ErrorUploadExceededText: 'O envio do arquivo {0} não pôde ser concluído, pois sua conta ficou sem espaço.',
    ErrorUploadText: 'O envio do arquivo {0} encontrou um erro desconhecido e não pôde ser concluído. Por favor, repita o processo de envio.',
    ErrorUploadTitle: 'Erro ao enviar arquivo.',
    ErrorVirusText: 'O arquivo que você está tentando anexar pode conter um vírus. Por favor, remova o arquivo e faça uma verificação no computador para sua segurança.',
    ErrorVirusTitle: 'Arquivo de vírus',
    exported: 'Exportado',
    exporting: 'Exportando',
    failed: 'Falhou',
    help: 'Ajuda',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#hora#horas',
    HourPluralFormatTemplate: '1#{0} hora#{0} horas',
    HyperLinkTooltip: 'CTRL+Clique para seguir o link',
    items_selected_plural: '1#{0} item selecionado#{0} itens selecionados',
    madeBy: 'Desenvolvido por',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'e mais {0}',
    next: 'Próximo',
    no_items_selected: 'Nenhum item selecionado',
    None_Text: 'Nenhum',
    Not_set: 'Não definido',
    Ok: 'OK',
    open_details_new_tab: 'Abrir detalhes em nova aba',
    open_in_new_tab: 'Abrir em nova aba',
    OpeningWindow: 'Abrindo...',
    OpenOriginal: 'Abrir original',
    OperationError_Title: 'A operação não pôde ser concluída',
    paragraph_text: 'Texto de parágrafo',
    parentActivity: 'atividade pai',
    PerDay: 'por dia',
    PerWeek: 'por semana',
    project_custom_fields_label: 'Campos personalizados do projeto',
    project_plural: '1#{0} projeto#{0} projetos',
    reject_label: 'Rejeitar',
    Remove: 'Remover',
    request_has_been_sent_successfully: 'A solicitação foi enviada com sucesso. A equipe de sucesso entrará em contato com você.',
    Request_Trial: 'Solicitar teste',
    Reset: 'Reiniciar',
    Save: 'Salvar',
    saved: 'Salvo',
    saving: 'Salvando',
    Search: 'Buscar',
    sending: 'Enviando',
    setCompleted: 'Definir como Concluído',
    show_less_label: 'Mostrar menos',
    show_more_label: 'Mostrar mais',
    space_exceeded_description: 'Não há espaço de armazenamento disponível suficiente para armazenar arquivos.',
    space_exceeded_title: 'Espaço está cheio',
    subscribe_trouble_description: 'Por favor, entre em contato com <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a> para esclarecer seu status de assinatura.',
    summary: 'Resumo',
    time_input_placeholder: 'Digite o tempo ex.: 2h 30m',
    timer_text: '1#{0} segundo#{0} segundos',
    title_notFullyCompleted: 'A operação não pôde ser concluída parcial ou totalmente',
    title_reload: 'Por favor, recarregue a página',
    total: 'Total',
    turn_off: 'Desligar',
    type: 'Tipo',
    Type_for_search: 'Tipo para pesquisa',
    Type_for_search_or_add: 'Tipo para pesquisar ou adicionar',
    Type_for_search_or_create: 'Tipo para pesquisar ou criar',
    unarchive_action_text: 'Desarquivar',
    undo_label: 'Desfazer',
    upload: 'Enviar',
    WebPushNotificationPanelLink: 'ativar notificações de área de trabalho.',
    WebPushNotificationPanelText: '{brandName} precisa da sua permissão para',
    you_user_text: 'você',
};
